import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useContextModal } from '@/components/Modal';
import Construction from '@/components/Preparing/Preparing';
import useQuery from '@/hooks/useQuery';

export const useMenu = () => {
  const layout = useSelector((state) => state.layout);

  const modal = useContextModal();

  const { query } = useQuery();
  const navigate = useNavigate();

  // multiple dropdown control
  const [dropdown, setDropdown] = useState({ person: false });

  const onToggleDropdown = (type) => {
    setDropdown((prev) => {
      let copied = { ...prev };

      for (const property in prev) {
        copied = {
          ...copied,
          [property]: property === type ? !prev[property] : false,
        };
      }
      return copied;
    });
  };

  const onRedirect = async (selected) => {
    onToggleDropdown('person');

    switch (selected.route) {
      case '/logout':
        {
          navigate('/logout');
        }
        break;
      case '/feadback':
        {
          window.open(
            `https://forms.monday.com/forms/818796a5269ce96741a02aaca6784f94?r=use1`,
            '_blank'
          );
        }
        break;
      case '/account':
        {
          navigate('/account');
        }
        break;
      default: {
        modal.open([
          <Construction key="not-ready" />,
          {
            size: 'lg',
            hasCloseButton: true,
          },
        ]);
      }
    }
  };

  return {
    query,
    layout,
    dropdown,
    onToggleDropdown,
    onRedirect,
  };
};
